// extracted by mini-css-extract-plugin
export var root = "Wild-module--root--2N3IV";
export var noWildImg = "Wild-module--noWildImg--3aYun";
export var container = "Wild-module--container--3G_6J";
export var titleCaption = "Wild-module--titleCaption--2IR1j";
export var title = "Wild-module--title--qbuMZ";
export var subTitle = "Wild-module--subTitle--1m3VJ";
export var mainWrapper = "Wild-module--mainWrapper--Y1Blh";
export var image = "Wild-module--image--2g_f6";
export var largeImg = "Wild-module--largeImg--2Qa81";
export var smallImg = "Wild-module--smallImg--10E8i";
export var leftImg0 = "Wild-module--leftImg0--3Heyy";
export var leftImg1 = "Wild-module--leftImg1--2Z0iw";
export var leftImg2 = "Wild-module--leftImg2--2rM6p";
export var centerImg0 = "Wild-module--centerImg0--21GGU";
export var centerImg1 = "Wild-module--centerImg1--2tA6p";
export var centerImg2 = "Wild-module--centerImg2--9uPPZ";
export var rightImg0 = "Wild-module--rightImg0--3Qfzv";
export var rightImg1 = "Wild-module--rightImg1--l3HfL";
export var rightImg2 = "Wild-module--rightImg2--VuLkt";
export var videoWrapper0 = "Wild-module--videoWrapper0--1vFf8";
export var videoWrapper1 = "Wild-module--videoWrapper1--3iuy2";
export var video = "Wild-module--video--hIFcB";